// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * ALMA Chatbot API
 * API to manage Alma chatbot interactions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  MainAskRequest,
  MainAskResponse,
  MainFeedbackRequest,
  MainFeedbackResponse,
} from '../models/index';
import {
  MainAskRequestFromJSON,
  MainAskRequestToJSON,
  MainAskResponseFromJSON,
  MainAskResponseToJSON,
  MainFeedbackRequestFromJSON,
  MainFeedbackRequestToJSON,
  MainFeedbackResponseFromJSON,
  MainFeedbackResponseToJSON,
} from '../models/index';

export interface AskPostRequest {
  body: MainAskRequest;
}

export interface FeedbackPostRequest {
  body: MainFeedbackRequest;
}

/**
 *
 */
export class ALMAApi extends runtime.BaseAPI {
  /**
   * Ask ALMA a question and get a response based on the Aura Portal documentation.
   * Ask ALMA a question
   */
  async askPostRaw(
    requestParameters: AskPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MainAskResponse>> {
    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling askPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/ask`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: MainAskRequestToJSON(requestParameters['body']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      MainAskResponseFromJSON(jsonValue),
    );
  }

  /**
   * Ask ALMA a question and get a response based on the Aura Portal documentation.
   * Ask ALMA a question
   */
  async askPost(
    requestParameters: AskPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MainAskResponse> {
    const response = await this.askPostRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Provide feedback on a answer from ALMA to help improve future responses.
   * Send feedback to ALMA
   */
  async feedbackPostRaw(
    requestParameters: FeedbackPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MainFeedbackResponse>> {
    if (requestParameters['body'] == null) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter "body" was null or undefined when calling feedbackPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/feedback`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: MainFeedbackRequestToJSON(requestParameters['body']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      MainFeedbackResponseFromJSON(jsonValue),
    );
  }

  /**
   * Provide feedback on a answer from ALMA to help improve future responses.
   * Send feedback to ALMA
   */
  async feedbackPost(
    requestParameters: FeedbackPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MainFeedbackResponse> {
    const response = await this.feedbackPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
